import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faUser, faPhone, faAddressCard, faGlobe, faTreeCity, faPen} from "@fortawesome/free-solid-svg-icons";
import {Fragment, useEffect, useState} from "react";
import {useForm, Controller} from "react-hook-form";
import {DatePicker, FormInputIcon, ReactSingleSelect} from '~/components';
import UserInformationAPI from "~/api/userInformationApi";
import { toast } from 'react-toastify';
function PersonalInfoTab({title}) {
    const [userInfo, setUserInfo] = useState({});
    const [userInformationDetails, setUserInformationDetails] = useState({});
    const [isDisableSave, setIsDisableSave] = useState(true);
    useEffect(() => {
        UserInformationAPI.getByUserId("0")
            .then(res => {
                setUserInformationDetails(res.data);
                const formValues = { ...res.data };
                formValues.DateOfBirth = res.data.DateOfBirth || [];
                formValues.Gender = res.data.Gender
                    ? { value: res.data.Gender, label: res.data.Gender }
                    : null;
                reset(formValues);
            })
            .catch(err => {
                
            })
    }, []);

    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm();

    const fields = [
        {field: "FirstName", label: "First Name", icon: faUser},
        {field: "LastName", label: "Last Name", icon: faUser},
        {field: "PhoneNumber", label: "Phone Number", icon: faPhone},
        {field: "Address", label: "Address", icon: faAddressCard},
        {field: "Country", label: "Country", icon: faGlobe},
        {field: "City", label: "City", icon: faTreeCity}
    ]

    const optionsGender = [
        { value: "Male", label: "Male" },
        { value: "Female", label: "Female" }
    ];


    const onSubmitFrom = (data) => {
        const payload = {
            ...data,
            Gender: data.Gender?.value ?? null,
            DateOfBirth: new Date(data.DateOfBirth?.[0]) ?? null
        };
        UserInformationAPI.updUserInformation(payload)
        .then(res => {
            res.data?.Success ?
                toast.success(<span className="fs-9 fw-bold">Your personal information has been updated.</span>)
                : toast.error(<span className="fs-9 fw-bold">An error occurred while updating your information.</span>)
        })
        .catch(err => {
            toast.error(<span className="fs-9 fw-bold">An error occurred while updating your information.</span>)
        })
    }

    return (
        <Fragment>
            <div className="mb-6">
                <h4 className="mb-4 text-center">{title}</h4>
                <form onSubmit={handleSubmit(onSubmitFrom)} id="formEditPersonalInfo">
                    <div className="row g-3">
                        {
                            fields.map((field, index) => (
                                <div className="col-12 col-sm-6" key={index}>
                                    <FormInputIcon
                                        showHeaderLabel={true}
                                        name={field.field}
                                        errors={errors}
                                        required={false}
                                        defaultValue={userInformationDetails[field.field]}
                                        maxLengthText=""
                                        icon={field.icon}
                                        label={field.label}
                                        disabled={isDisableSave}
                                        validation={{...register(field.field)}}
                                    />
                                </div>
                            ))
                        }
                        <div className="col-12 col-sm-6">
                            <span className="form-label">Day of birth</span>
                            <Controller
                                name="DateOfBirth"
                                control={control}
                                render={({ field }) => (
                                    <DatePicker
                                        value={field.value || []}
                                        onChange={(dates) => {
                                            field.onChange(dates)
                                        }}
                                        placeholder="Select date of birth..."
                                        disabled={isDisableSave}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-12 col-sm-6">
                            <span className="form-label">Gender</span>
                            <Controller
                                name="Gender"
                                control={control}
                                render={({ field }) => (
                                    <ReactSingleSelect
                                        options={optionsGender}
                                        value={field.value}
                                        onChange={field.onChange}
                                        placeholder="Select gender..."
                                        disabled={isDisableSave}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </form>
            </div>
            <div className="text-end mb-6">
                <div>
                    {
                        isDisableSave && (
                        <button type="button" onClick={()=> setIsDisableSave(false)}
                            className="btn btn-bt-primary me-2">Edit
                            <FontAwesomeIcon className="ms-3" icon={faPen}/>
                        </button>
                        )
                    }
                    {
                        !isDisableSave &&
                        (
                            <button type="button" onClick={()=> setIsDisableSave(true)}  className="btn btn-bt-primary me-2">Cancel Change
                            </button>
                        )
                    }
                    <button type="submit" disabled={isDisableSave} form="formEditPersonalInfo" className="btn btn-bt-primary">Save Information</button>
                </div>
            </div>
        </Fragment>
    )
}

export default PersonalInfoTab;